import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import HeaderCreation from "../../components/Add_Campaign/headerCreation";
import BodyCreation from "../../components/Add_Campaign/bodyCreation";
import FooterCreation from "../../components/Add_Campaign/footerCreation";
import GetCampaignId from "./getCampaignId";
import "./styles/headerdata.css";
import { Paper } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
const steps = ["create Header", "Create body", "Create Footer"];

const AddCampaign = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [stepOne, setstepOne] = React.useState(true);
  const [skipped, setSkipped] = React.useState(new Set());
  const navigate = useNavigate();


  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    localStorage.setItem("backClicked", true);
  };

  const handleReset = () => {
    navigate("/view-campaign");
    localStorage.removeItem("updateID");
  };


  
  return (
    <>
      {stepOne ? (
        <GetCampaignId setstepOne={setstepOne} setActiveStep={setActiveStep} />
      ) : (
        <Box sx={{ width: "100%" }}>
          <Stepper activeStep={activeStep} sx={{ boxShadow: "0 4px 12px rgba(0, 165, 162, 0.3)", width: "98%", marginBottom: "1rem", borderRadius: "3px" }}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              if (isStepOptional(index)) {
                labelProps.optional = (
                  <Typography variant="caption"></Typography>
                );
              }
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} className="mb-2">
                  <StepLabel
                    StepIconComponent={(props) => (
                      <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ duration: 0.3, delay: index * 0.1 }}
                        className={"mt-2"}
                      >
                        <div
                          style={{
                            backgroundColor:
                              props.active || props.completed
                                ? "rgba(0, 165, 162, 0.7)"
                                : "#ccc",
                            color: "white",
                            borderRadius: "50%",
                            padding: "8px",
                            fontSize: "12px",
                            width: "40px",
                            height: "40px",
                            textAlign: "center",
                            lineHeight: "25px"
                          }}
                        >
                          {props.icon}
                        </div>
                      </motion.div>
                    )}
                  >
                    <motion.span
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: index * 0.15 }}
                      style={{
                        fontWeight: activeStep === index ? "bold" : "normal",
                        color: activeStep === index ? "#0aa5a2" : "inherit",
                      }}
                    >
                      {label}
                    </motion.span>
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <img
                  src="https://storage.googleapis.com/public-images-plutosone/cbms/campaign/image-1749447291189-240_F_1138076808_Yz5MeBAhBu5u47PWSYZnFcNBvMPicAe8.jpg"
                  alt="Success"
                  style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                />
              </Box>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  display: "flex",
                  justifyContent: "center",
                  color: "green",
                }}
              >
                All steps completed.
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
                <Button
                  onClick={handleReset}
                  variant="contained"
                  color="warning"
                >
                  Go Back to Create New Campaign
                </Button>
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Paper elevation={3} sx={{ width: "98%" }}>
                <Box
                  sx={{
                    padding: "2rem",
                    borderRadius: "16px",
                  }}
                >
                  {activeStep === 0 ? (
                    <HeaderCreation
                      handleNext={handleNext}
                      handleBack={handleBack}
                      activeStep={activeStep}
                    />
                  ) : activeStep === 1 ? (
                    <BodyCreation
                      handleNext={handleNext}
                      handleBack={handleBack}
                      activeStep={activeStep}
                    />
                  ) : (
                    <FooterCreation
                      handleNext={handleNext}
                      handleBack={handleBack}
                      activeStep={activeStep}
                    />
                  )}
                </Box>
              </Paper>
            </React.Fragment>
          )}
        </Box>
      )}
    </>
  );
};

export default AddCampaign;
